import React, { useEffect, useState } from 'react'
import Footer from './Footer';
import { useUserWalletQuery } from './store/ReduxApis';
import ReactPaginate from 'react-paginate';
import uuid from 'react-uuid';
import { TablePagination } from '@material-ui/core';



function UserWallet() {

    const wallet = useUserWalletQuery();

    const [searchTerm, setSearchTerm] = useState("")
    const [dateFilter, setDateFilter] = useState("");

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = event => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const formatDate = (timestamp) => new Date(Number(timestamp)).toLocaleDateString();

    return (
        <div>
            <div class="content-wrapper">

                <section class="content-header">
                    <div class="container-fluid">

                        <div class="row mb-2">
                            <div class="col-sm-6 text">
                                <h1>User Wallet Info</h1>
                            </div>
                            <div class="col-sm-6">
                                <ol class="breadcrumb float-sm-right">
                                    <li class="breadcrumb-item"><a href="#">Home</a></li>
                                    <li class="breadcrumb-item active">User Wallet Info</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>


                <section class="content">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-12">
                                <div class="card">
                                    <div class="card-header cards">
                                        <h3 class="card-title">Get all the user wallet details</h3>
                                        <div class="box-tools">

                                        </div>
                                    </div>


                                    <div class="card-body">
                                        <div class="table-responsive">
                                            <div className='pagination'>
                                                <h6 className='page'>Show 1 to {wallet?.data?.wallet?.length} entries</h6>
                                                <TablePagination

                                                    className='pagi'
                                                    rowsPerPageOptions={[5, 10, 30]}
                                                    component="div"
                                                    count={wallet?.data?.wallet?.length}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    onChangePage={handleChangePage}
                                                    onChangeRowsPerPage={handleChangeRowsPerPage}
                                                    />
                                            </div>

                                            <table id="example" class="table table-bordered table-striped table-hover" datatable>
                                                <thead>
                                                    <tr>
                                                        <th>User Wallet Address</th>
                                                        <th>Date</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {wallet && wallet?.data?.wallet?.filter((value) => {
                                                         const matchAddress = searchTerm === "" || value.user_wallet.toLowerCase().includes(searchTerm.toLowerCase());

                                                         const matchDate = dateFilter === "" || formatDate(value.registerTime).includes(dateFilter);
 
                                                         return matchAddress && matchDate;
                                                    }).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(e => (
                                                        // <tr className='tr'>
                                                        //     <td>{e.user_wallet}</td>
                                                        //     <td>{new Date(Number(e.registerTime)).toLocaleDateString()}</td>
                                                         
                                                        // </tr>
                                                        <tr key={e._id}>
                                                            <td>{e.user_wallet}</td>
                                                            <td>{formatDate(e.registerTime)}</td>
                                                        </tr>
                                                    ))}


                                                    <td>

                                                        <div className='paginate'>

                                                            {/* <ReactPaginate
          previousLabel={"Previous"}
          nextLabel={"Next"}
          pageCount={pageCount}
          onPageChange={changePage}
          containerClassName={"paginationBttns"}
          previousLinkClassName={"previousBttn"}
          nextLinkClassName={"nextBttn"}
          disabledClassName={"paginationDisabled"}
          activeClassName={"paginationActive"}
      /> */}
                                                        </div>

                                                    </td>

                                                </tbody>

                                                <tfoot>
                                                    <tr>
                                                    <th>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                onChange={(e) => setSearchTerm(e.target.value)}
                                                                autoComplete="off"
                                                                placeholder="Wallet Address"
                                                                name="search-Id"
                                                            />
                                                        </th>
                                                        <th>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                onChange={(e) => setDateFilter(e.target.value)}
                                                                autoComplete="off"
                                                                placeholder="Date"
                                                                name="search-sourceAmount"
                                                            />
                                                        </th>
                                                    </tr>
                                                </tfoot>

                                            </table>





                                        </div>

                                    </div>



                                </div>

                            </div>


                        </div>
                    </div>
                </section>
                <Footer></Footer>

            </div>

        </div>
    )
}

export default UserWallet